import React from "react";
import { VisitStaffingPreferences } from "../messages/Visit";
import { assertUndefinedable } from "../utils/assertUndefinedable";
import BadgesGroup from "./BadgesGroup";
import { isDefined } from "./Generic/IsDefined";

interface TrueFalseMessageMapObject {
  true: string;
  false?: string;
}

interface Props {
  staffingPreferences: VisitStaffingPreferences;
}

const staffingPreferenceToText: Record<keyof VisitStaffingPreferences, TrueFalseMessageMapObject> =
  {
    smoking: { true: "Smoking", false: "Not smoking" },
    bedbound: { true: "Bedbound" },
    cane: { true: "Cane" },
    walker: { true: "Walker" },
    wheelchair: { true: "Wheelchair" },
    kosher: { true: "Kosher" },
    halal: { true: "Halal" },
    hoyer: { true: "Hoyer lift" },
    pets: { true: "Has pets", false: "No pets" },
  };

const VisitStaffingPreferencesBadges = (props: Props) => {
  const staffingPreferences = [];
  for (const [key, value] of Object.entries(props.staffingPreferences)) {
    const preferenceKey = key as keyof VisitStaffingPreferences;
    const boolKey = `${value}` as keyof TrueFalseMessageMapObject;
    const preference = assertUndefinedable(staffingPreferenceToText[preferenceKey]);
    const text = preference?.[boolKey];

    if (isDefined(text)) {
      staffingPreferences.push({
        text: text,
        icon: `assets/staffing_preferences_${key}.svg`,
      });
    }
  }

  return <BadgesGroup labels={staffingPreferences} />;
};

export default VisitStaffingPreferencesBadges;
